import { createFileRoute } from '@tanstack/react-router';
import { PageContent } from '@/components/page-content';
import { PrivacyRequests } from '@/components/settings/privacy-requests';

export const Route = createFileRoute(
  '/_auth/_side-layout/settings_/privacy/requests',
)({
  component: () => (
    <PageContent>
      <PrivacyRequests />
    </PageContent>
  ),
});
